import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../config/firebase';

/**
 * Hook to track page views automatically on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
        page_location: window.location.href,
      });
    }
  }, [location]);
};

/**
 * Analytics event tracking functions
 */
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

// Specific tracking functions for common actions
export const analyticsEvents = {
  // Item actions
  addItem: (type: 'place' | 'experience') => {
    trackEvent('add_item', { item_type: type });
  },
  
  updateItem: (id: string, type: 'place' | 'experience') => {
    trackEvent('update_item', { item_id: id, item_type: type });
  },
  
  deleteItem: (id: string, type: 'place' | 'experience') => {
    trackEvent('delete_item', { item_id: id, item_type: type });
  },
  
  toggleComplete: (id: string, completed: boolean) => {
    trackEvent('toggle_complete', { item_id: id, completed });
  },
  
  // Navigation
  viewItemDetails: (id: string, type: 'place' | 'experience') => {
    trackEvent('view_item_details', { item_id: id, item_type: type });
  },
  
  viewMap: () => {
    trackEvent('view_map');
  },
  
  // Auth
  login: (method: string) => {
    trackEvent('login', { method });
  },
  
  logout: () => {
    trackEvent('logout');
  },
  
  // Filters and sorts
  applyFilter: (filterType: string, value: string) => {
    trackEvent('apply_filter', { filter_type: filterType, value });
  },
  
  applySort: (sortBy: string) => {
    trackEvent('apply_sort', { sort_by: sortBy });
  },
  
  // PWA
  installPWA: () => {
    trackEvent('install_pwa');
  },
  
  updatePWA: () => {
    trackEvent('update_pwa');
  },
};
